import {useAddToCartOffCanvas} from "../../redux/stateHooks";
import {ResourceType} from "../../definitions/types";
import {DesignServiceModel} from "../../models/domain/designServiceModel";
import {DesignServicesModel} from "../../models/view/designServicesModel";

/**
 * Returns the design service for the current off canvas product.
 * @param designServiceId
 * @returns {{productDesignService: DesignServiceModel | undefined; designServices: DesignServiceModel[]}}
 */
export const useOffCanvasDesignService = (designServiceId?: number): {
    productDesignService: DesignServiceModel | undefined;
    designServices: DesignServiceModel[]
} => {
    // Get the current off canvas product
    const {product} = useAddToCartOffCanvas();
    // Filter out null resources
    const resources = (product?.resources ?? []).filter((res): res is ResourceType => res !== null)
    // Get the design services for the off canvas product
    const designServices = new DesignServicesModel(resources).designServices
    // Get the design service for the off canvas product for the given design service id
    const designService = designServices.find(designService => designService.id == designServiceId)
    // Return the design service
    return {productDesignService: designService, designServices};
}